import React from "react";
import Navbar from "./navbar/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "./footer/Footer";

function Layout() {
  return (
    <>
      {/* Main application structure */}
      <div 
        className="app-container"
        style={{
          position: 'relative',
          minHeight: '100vh',
          /* Ensure proper stacking context */
          isolation: 'isolate',
        }}
      >
        <Navbar />
        <main className="main-content">
          <Outlet />
        </main>
        <Footer />
      </div>

      {/* Additional CSS for layout optimization */}
      <style jsx global>{`
        /* Ensure body doesn't have overflow issues on mobile */
        body {
          overflow-x: clip;
          /* Better font rendering */
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        /* Main container improvements */
        .app-container {
          position: relative;
          width: 100%;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .main-content {
          flex: 1;
          position: relative;
          /* Ensure content doesn't interfere with fixed WhatsApp button */
          z-index: 1;
        }

        /* Responsive improvements for different screen sizes */
        @media screen and (max-width: 480px) {
          body {
            /* Prevent horizontal scroll on very small screens */
            overflow-x: clip;
          }

          .app-container {
            /* Ensure full width on mobile */
            width: 100vw;
            max-width: 100%;
          }
        }

        /* Tablet specific optimizations */
        @media screen and (min-width: 768px) and (max-width: 1024px) {
          .main-content {
            /* Better spacing on tablets */
            padding: 0;
          }
        }

        /* Desktop optimizations */
        @media screen and (min-width: 1025px) {
          .app-container {
            /* Better performance on larger screens */
            will-change: auto;
          }
        }

        /* Ensure WhatsApp button doesn't interfere with page scrolling */
        html {
          scroll-padding-right: 80px; /* Account for WhatsApp button */
        }

        @media screen and (max-width: 768px) {
          html {
            scroll-padding-right: 70px; /* Smaller padding on mobile */
          }
        }

        /* Prevent layout shift when scrollbars appear */
        html {
          overflow-y: scroll;
        }
      `}</style>
    </>
  );
}

export default Layout;